"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _PaymentContext = _interopRequireDefault(require("../context/PaymentContext"));
var _containers = require("../containers");
var _Common = require("../components/Common");
var _browser = require("../browser");
var _api = require("../utils/api");
var _flywire = require("../utils/flywire");
var _folio = require("../utils/folio");
var _misc = require("../utils/misc");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Payment = function (_PureComponent) {
  function Payment() {
    var _this;
    (0, _classCallCheck2["default"])(this, Payment);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
    return _this = _callSuper(this, Payment, [].concat(args)), (0, _defineProperty2["default"])(_this, "state", {
      initializing: true,
      initialized: false,
      sessionToken: null,
      amount: _this.props.amount,
      notification: {},
      warning: {},
      captured: false,
      folio: null,
      paymentOptions: _this.props.paymentOptions
    }), (_this = _callSuper(this, Payment, [].concat(args)), (0, _defineProperty2["default"])(_this, "state", {
      initializing: true,
      initialized: false,
      sessionToken: null,
      amount: _this.props.amount,
      notification: {},
      warning: {},
      captured: false,
      folio: null,
      paymentOptions: _this.props.paymentOptions
    }), _this);
  }
  return (0, _inherits2["default"])(Payment, _PureComponent), (0, _createClass2["default"])(Payment, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (!(0, _flywire.isFlywireReentry)()) {
        var _this$props = this.props,
          tenant = _this$props.tenant,
          endpoints = _this$props.endpoints,
          intl = _this$props.intl,
          configs = _this$props.configs;
        var preparationConfigs = {
          tenantId: tenant.id,
          locale: intl.locale,
          url: endpoints.prepareSession.url,
          method: endpoints.prepareSession.method,
          params: endpoints.prepareSession.params,
          env: configs.env
        };
        (0, _api.prepareSession)(preparationConfigs, function (err, res) {
          return err ? void _this2.handleInitError(err) : void _this2.handleInitSuccess(res);
        });
      }
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this$props2 = this.props,
        onSubmit = _this$props2.onSubmit,
        muteWarnings = _this$props2.configs.muteWarnings;
      !muteWarnings && typeof onSubmit !== 'function' || onSubmit();
    }
  }, {
    key: "handleError",
    value: function handleError(error) {
      var _this$props3 = this.props,
        onError = _this$props3.onError,
        muteWarnings = _this$props3.configs.muteWarnings;
      !muteWarnings && typeof onError !== 'function' || onError(error);
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(response) {
      this.setState({
        captured: true
      });
      var _this$props4 = this.props,
        onSuccess = _this$props4.onSuccess,
        muteWarnings = _this$props4.configs.muteWarnings;
      !muteWarnings && typeof onSuccess !== 'function' || onSuccess(response);
    }
  }, {
    key: "handleInitError",
    value: function handleInitError(error) {
      this.setState({
        initialized: false,
        initializing: false
      });
      var _this$props5 = this.props,
        onInitError = _this$props5.onInitError,
        muteWarnings = _this$props5.configs.muteWarnings;
      !muteWarnings && typeof onInitError !== 'function' || onInitError(error);
    }
  }, {
    key: "handleInitSuccess",
    value: function handleInitSuccess(response) {
      var _this$props6 = this.props,
        intl = _this$props6.intl,
        source = _this$props6.source;
      var token = response.token,
        folio = response.folio;
      var notification = {};
      (0, _misc.isWithinGoToPeriod)(folio, source) && (notification.goToCampaign = true), this.setState(function (prevState) {
        return {
          initialized: true,
          initializing: false,
          sessionToken: token,
          folio: folio,
          paymentOptions: folio ? (0, _folio.getPaymentOptions)(folio, prevState.amount, intl.formatMessage) : prevState.paymentOptions,
          amount: folio ? undefined : prevState.amount,
          notification: notification
        };
      });
      var _this$props7 = this.props,
        onInitSuccess = _this$props7.onInitSuccess,
        muteWarnings = _this$props7.configs.muteWarnings;
      !muteWarnings && typeof onInitSuccess !== 'function' || onInitSuccess(response);
    }
  }, {
    key: "handleAmountSelected",
    value: function handleAmountSelected(amount) {
      var folio = this.state.folio;
      var _this$props8 = this.props,
        lowWarnAmount = _this$props8.lowWarnAmount,
        highWarnAmount = _this$props8.highWarnAmount;
      var lowAmount = folio ? (0, _folio.getDepositBalance)(folio) : lowWarnAmount;
      var highAmount = folio ? folio.outstandingTotal : highWarnAmount;
      var amountWarning = {
        isLowAmount: amount < lowAmount,
        isHighAmount: amount > highAmount
      };
      (amountWarning.isLowAmount || amountWarning.isHighAmount) && this.setState({
        warning: amountWarning
      }), this.setState({
        amount: amount
      });
      var _this$props9 = this.props,
        onAmountSelected = _this$props9.onAmountSelected,
        muteWarnings = _this$props9.configs.muteWarnings;
      !muteWarnings && typeof onAmountSelected !== 'function' || onAmountSelected(amount);
    }
  }, {
    key: "contextValue",
    get: function get() {
      var _this3 = this;
      var _this$state = this.state,
        sessionToken = _this$state.sessionToken,
        amount = _this$state.amount,
        warning = _this$state.warning,
        notification = _this$state.notification,
        captured = _this$state.captured,
        folio = _this$state.folio,
        paymentOptions = _this$state.paymentOptions;
      return {
        tenant: this.props.tenant,
        guestSource: this.props.guestSource,
        guestId: this.props.guestId,
        paymentStore: {
          amount: amount,
          warning: warning,
          notification: notification,
          sessionToken: sessionToken,
          captured: captured,
          folio: folio
        },
        phoneProto: this.props.phoneProto,
        actions: {
          setAmount: function setAmount(amount) {
            return _this3.handleAmountSelected(amount);
          },
          clearWarning: function clearWarning() {
            return _this3.setState({
              warning: {}
            });
          },
          clearNotification: function clearNotification() {
            return _this3.setState({
              notification: {}
            });
          }
        },
        callbacks: {
          onSubmit: function onSubmit() {
            return _this3.handleSubmit();
          },
          onError: function onError(error) {
            return _this3.handleError(error);
          },
          onSuccess: function onSuccess(response) {
            return _this3.handleSuccess(response);
          },
          onUnverified: this.props.onUnverified
        },
        providers: this.props.providers,
        preferredProvider: this.props.preferredProvider,
        paymentOptions: paymentOptions,
        endpoints: this.props.endpoints
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
        initialized = _this$state2.initialized,
        initializing = _this$state2.initializing,
        sessionToken = _this$state2.sessionToken;
      return (0, _flywire.isFlywireReentry)() ? _react["default"].createElement(_PaymentContext["default"].Provider, {
        value: this.contextValue
      }, _react["default"].createElement(_browser.Container, {
        margin: "small"
      }, _react["default"].createElement(_containers.FlywireResult, null))) : initializing ? _react["default"].createElement(_browser.Container, {
        margin: "small",
        minHeight: "inherit"
      }, _react["default"].createElement(_Common.Loader, null)) : initialized && sessionToken ? _react["default"].createElement(_PaymentContext["default"].Provider, {
        value: this.contextValue
      }, _react["default"].createElement(_browser.Container, {
        margin: "small"
      }, _react["default"].createElement(_containers.Payment, null))) : null;
    }
  }]);
}(_react.PureComponent);
(0, _defineProperty2["default"])(Payment, "defaultProps", {
  preferredProvider: null,
  paymentOptions: []
});
var _default = exports["default"] = (0, _reactIntl.injectIntl)(Payment);